import {
  LibertyLakeConfig,
  LibertyLakeFamilyInfo,
  LibertyLakeKid
} from '../../types/libertyLakeV2'
import { PayloadAction, createSlice } from '@reduxjs/toolkit'

interface LibertyLakeInitialState {
  step: number
  kids: LibertyLakeKid[]
  familyInfo: LibertyLakeFamilyInfo
  config: LibertyLakeConfig | undefined
}

const initialState: LibertyLakeInitialState = {
  step: 1,
  kids: [],
  familyInfo: {
    firstName: '',
    lastName: '',
    email: '',
    phone: '',
    city: '',
    occupation: 'None',
    isNewFamily: false,
    earlyPayOption: ''
  },
  config: undefined
}

const libertyLakeSlice = createSlice({
  name: 'libertyLake',
  initialState,
  reducers: {
    setStepNumber: (state, action: PayloadAction<number>) => {
      state.step = action.payload
    },
    setKids: (state, action: PayloadAction<LibertyLakeKid[]>) => {
      state.kids = action.payload
    },
    setFamilyInfo: (
      state,
      action: PayloadAction<LibertyLakeFamilyInfo>
    ) => {
      state.familyInfo = action.payload
    },
    setConfig: (state, action: PayloadAction<LibertyLakeConfig>) => {
      state.config = action.payload
    },
    resetLibertyLakeState: (state) => {
      state.step = 1
      state.kids = []
      state.familyInfo = {
        firstName: '',
        lastName: '',
        email: '',
        phone: '',
        city: '',
        occupation: 'None',
        isNewFamily: false,
        earlyPayOption: ''
      }
    }
  }
})

export default libertyLakeSlice
